var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubstack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1v5.434h40V1H4zm0 10.333v5.51h40v-5.51H4zm0 10.333V47c1.635-.478 3.277-1.774 4.764-2.613l9.98-5.642c1.237-.698 2.476-1.391 3.706-2.1.402-.23 1.082-.806 1.556-.798.466.009 1.144.589 1.544.82 1.152.667 2.315 1.32 3.478 1.967 3.517 1.955 6.994 3.985 10.51 5.94 1.36.756 2.95 2.076 4.462 2.426V21.666H4z",
    fill: "#FF6719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstack);
export default __webpack_public_path__ + "static/media/substack.cdcdc7bdf5986d10d653e95877331ffc.svg";
export { ForwardRef as ReactComponent };